import React from 'react';
import styled from 'styled-components';

const SignupSuccess = () => {
  return (
    <Container>
      <Title>会員登録完了</Title>

      <div className="description">
        <p>会員登録確認用のメールをお送りしました。</p>
        <p>メールをご確認ください。</p>
      </div>
    </Container>
  );
};

export {SignupSuccess};

const Container = styled.div`
  padding-top: 90px;
  padding-bottom: 200px;
  text-align: center;
  width: 400px;
  margin: 0 auto;

  .description {
    margin-top: 20px;
    margin-bottom: 40px;
    font-size: 12px;
    line-height: 1.5;
    color: #2c2c2c;

    p {
      margin-bottom: 0;
    }
  }
`;

const Title = styled.h1`
  margin-bottom: 70px;
  font-size: 26px;
  font-weight: 500;
  text-align: center;
  color: #666666;
`;
